import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import ScreeningService from '../../common/ScreeningService'

export const getTotalResult = createAsyncThunk(
  'tool/screening/getTotalResult',
  async (params, { rejectWithValue }) => {
    try {
      const response = await ScreeningService.getTotalResult(params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getSuggestData = createAsyncThunk(
  'tool/screening/getSuggestData',
  async ({ path, params }, { rejectWithValue }) => {
    try {
      const response = await ScreeningService.getSuggestData(path, params)
      if (response.success) return response.data
      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
